import * as types from './mutationTypes';

export default {
  setMobile({ commit }, isMobile) {
    commit(types.SET_MOBILE, isMobile);
  },
  toggleLoading({ commit }, show) {
    commit(types.SET_LOADING, show);
  },
  hideToast({ commit }) {
    commit(types.HIDE_TOAST);
  },
  showToastSuccess({ dispatch }, message) {
    dispatch('showToast', { message, type: 'success' });
  },
  showToastError({ dispatch, state }, message) {
    if (!message || state?.auth?.sessionOff) return;

    dispatch('showToast', { message, type: 'error' });
  },
  showToast({ commit, dispatch, state }, { type, message, timeout }) {
    if (!message || state?.auth?.sessionOff) return;

    commit(types.SHOW_TOAST, { type, message, timeout });
    if (type === 'success') {
      setTimeout(() => {
        dispatch('hideToast');
      }, state.toast.timeout);
    }
  },
  setModalPermission({ commit }, show) {
    commit(types.SET_MODAL_PERMISSION, { show });
  },
};
